import React from 'react'
import Navbar from '../../components/Navbar'
import ManagerCard from '../../components/ManagerCard'
import ManagerPortfolio from '../../components/ManagerPortfolio'

const Manager = () => {
    return(
      <>
       <ManagerCard />
       <ManagerPortfolio />
      </>
    )
  }
  
  export default Manager